import { useQuery } from 'react-query';
import { getHeyGenAvatars } from '../shared/utils/VideoGeneration/helperFunctions/tavusApi';

interface UseGetHeyGenAvatarsParams {
  limit?: number;
  offset?: number;
}

export default function useGetHeyGenAvatars(params: UseGetHeyGenAvatarsParams = {}) {
  const { data, isLoading, error, refetch } = useQuery(
    ['get-heygen-avatars', params.limit || 20, params.offset || 0],
    () => getHeyGenAvatars({
      limit: params.limit || 20,
      offset: params.offset || 0
    }),
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      refetchOnWindowFocus: false,
      enabled: true,
      retry: false
    }
  );

  return {
    data: data?.avatars || [],
    pagination: data?.pagination,
    isLoading,
    error,
    refetch
  };
}

